var _polyline, _polyline2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinimize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "4 14 10 14 10 20"
})), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
  points: "20 10 14 10 14 4"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 14,
  x2: 21,
  y1: 10,
  y2: 3
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 3,
  x2: 10,
  y1: 21,
  y2: 14
})));
export default SvgMinimize;